import services from 'util/services'

function useAdmin () {
  const user = services?.getUser()
  const isAdmin = user?.roles?.some(rol => rol.name.toLowerCase() === 'admin')
  return isAdmin
}

export default useAdmin
